import { MailingId } from 'modules/mailing/types/mailing-interface'

export const getEmailStatisticsUrl = (mailingId: MailingId) => `/mailing/${mailingId}/statistics`
